const Header = () => {
  return (
    <>
      <header className='container'>
        <h1 className="header-h1"> Quiz </h1>
      </header>
    </>
  );
};

export default Header;
